import React from "react";
import "./Footer.css";
import FooterText from "../components/FooterText";
import FooterTitle from "../components/FooterTitle";
import location from './../assets/location.png'
import call from './../assets/call.png'
import email from './../assets/email.png'
import facebook from './../assets/facebook.png'
import twitter from './../assets/twitter.png'
import lin from './../assets/in.png'
import ig from './../assets/ig.png'

const Footer = () => {
  return (
    <footer className="footer">
    <div className="text-container-footer">
        <div className="text-box-footer">
            <div className="logo-text">Sterling & Associates</div>
            <div className="line5"></div>
            <FooterText text='Excellence in legal representation with integrity and dedication to client success since 1995.' style1='para'/>
        </div>

        <div className="text-box-footer">
            <FooterTitle text='Quick Links' style2='title-footer'/>
            <FooterText text='About Us' style1='para'/>
            <FooterText text='Practice Areas' style1='para'/>
            <FooterText text='Our Attorneys' style1='para'/>
            <FooterText text='Testimonials' style1='para'/>
            <FooterText text='Contact' style1='para'/>
        </div>

        <div className="text-box-footer">
            <FooterTitle text='Practice Areas' style2='title-footer'/>
            <FooterText text='Corporate Law' style1='para'/>
            <FooterText text='Criminal Law' style1='para'/>
            <FooterText text='Family Law' style1='para'/>
            <FooterText text='Real Estate Law' style1='para'/>
            <FooterText text='Intellectual Property' style1='para'/>
            <FooterText text='Civil Litigation' style1='para'/>
        </div>

        <div className="text-box-footer">
            <FooterTitle text='Contact Info' style2='title-footer'/>
            <div className="contact-box">
            <img src={location}/>
            <FooterText text='123 Legal Plaza, Suite 400' style1='para'/>
            </div>

            <div className="contact-box">
            <img src={call}/>
            <FooterText text='+1 (555) 123-4567' style1='para'/>
            </div>

            <div className="contact-box">
            <img src={email}/>
            <FooterText text='info@sterlinglaw.com' style1='para'/>
            </div>
        </div>
    </div>
    
    <div className="footer-line"></div>

    <div className="icon-footer">
    <FooterText text='© 2026 Sterling & Associates. All rights reserved.' style1='para'/>
    <div className="icons-con">
    <div className="icon-box-footer">
        <img src={facebook}/>
    </div>
    <div className="icon-box-footer">
        <img src={twitter}/>
    </div>
    <div className="icon-box-footer">
        <img src={lin}/>
    </div>
    <div className="icon-box-footer">
        <img src={ig}/>
    </div>
    </div>
    </div>
    </footer>
  );
};

export default Footer;